<template>
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="m1.8172 2.1867h2.3674v0.93755h-2.3674c-0.19934 0-0.38097
    0.07048-0.51299 0.18392-0.13192 0.11344-0.21388 0.26962-0.21388
    0.44112v14.688c0 0.3427 0.32837 0.6249 0.72687 0.6249h14.366c0.3984 0
    0.7269-0.2824
    0.7269-0.6249v-14.688c0-0.17126-0.082-0.32752-0.214-0.44104s-0.3135-0.184-0.5129-0.184h-2.3673v-0.93755h2.3673c0.5003
    0 0.9547 0.17572 1.2837 0.4587 0.3291 0.28298 0.5335 0.67386 0.5335
    1.1039v14.688c0 0.86-0.8171 1.5625-1.8172 1.5625h-14.366c-1.0003
    0-1.8172-0.7024-1.8172-1.5625v-14.688c0-0.43018 0.20434-0.82098
    0.53334-1.1039 0.32909-0.28298 0.78356-0.4587
    1.2838-0.4587zm7.1829-2.1867c0.5268 0 1.0038 0.027502 1.3492 0.32432 0.3452
    0.29697 0.5588 0.70714 0.5588
    1.1601h2.1806v2.3439h-8.1772v-2.3439h2.1806c0-0.453 0.21361-0.86318
    0.55887-1.1601 0.34526-0.29689 0.82227-0.32432 1.3492-0.32432zm0.57823
    0.98724c-0.14792-0.1272-0.35235-0.20595-0.57823-0.20595-0.22587 0-0.4304
    0.078754-0.57831 0.20595-0.14792 0.1272-0.23942 0.30299-0.23942
    0.49722s0.0915 0.37002 0.23942 0.49721c0.13865 0.11923 0.32709 0.19595
    0.53624 0.20501h0.08414c0.20916-0.00906 0.39751-0.08578 0.53616-0.20501
    0.14791-0.12719 0.23941-0.30298
    0.23941-0.49721s-0.0915-0.37002-0.23941-0.49722z"
    />
    <path
      d="m3.7303 14.14h10.539v0.6251h-10.539v-0.6251zm-2.7e-4
    -4.1397h1.6634l1.0757-2.3002c0.0745-0.15978 0.28556-0.23736 0.47128-0.17337
    0.09785 0.03375 0.16918 0.09992 0.20389 0.17844l5.4e-4 -2.3e-4 1.6156 3.6283
    1.4499-4.7887c0.0501-0.1665 0.2478-0.2665 0.4415-0.22338 0.1131 0.02524
    0.1999 0.09376 0.2424 0.17962l2e-4 -1.5e-4 1.7057
    3.4216h1.6693v0.62504h-1.908v-8e-4c-0.1409
    0-0.2749-0.0712-0.3336-0.1897l-1.3831-2.7747-1.4622 4.8291c-0.02281
    0.103-0.10531 0.1939-0.22751 0.2338-0.18735
    0.0614-0.39715-0.0195-0.46847-0.1806l-1.6896-3.7945-0.81245 1.7374c-0.04661
    0.1264-0.18408 0.218-0.34654 0.218h-1.908v-0.6249h9e-5zm2.7e-4
    5.7808h10.539v0.625h-10.539v-0.625z"
      clip-rule="evenodd"
      fill-rule="evenodd"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PrescricaoMinCuidadoIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
